import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { IoArrowForward, IoClose } from "react-icons/io5";
import { useAuth } from "@/context/AuthContext";
import { getUnseenReply, getPageConfig } from "@/lib/api";

const RED = "#e11d2a";

/** Alerte plein écran : Nerodus prévient l'élève qu'une relecture a reçu une réponse. */
export default function ReviewAlert() {
  const nav = useNavigate();
  const loc = useLocation();
  const { isAuthenticated, isAdmin, user } = useAuth();
  const [data, setData] = useState(null);
  const [img, setImg] = useState("/nerodus.png");
  const [entered, setEntered] = useState(() => typeof window !== "undefined" && sessionStorage.getItem("sx_intro_shown") === "1");

  useEffect(() => {
    if (entered) return;
    const onDone = () => setEntered(true);
    window.addEventListener("td-intro-done", onDone);
    return () => window.removeEventListener("td-intro-done", onDone);
  }, [entered]);

  useEffect(() => {
    if (!entered || !isAuthenticated || isAdmin) { setData(null); return; }
    if (loc.pathname.startsWith("/connexion") || loc.pathname.startsWith("/inscription") || loc.pathname.startsWith("/profil")) return;
    getUnseenReply().then((r) => { if (r?.unseen) setData(r); }).catch(() => {});
    getPageConfig("nerodus").then((n) => n?.image && setImg(n.image)).catch(() => {});
    // eslint-disable-next-line
  }, [entered, isAuthenticated, isAdmin, loc.pathname]);

  if (!data) return null;
  const first = (user?.name || "").split(" ")[0];
  const go = () => { const id = data.entry_id; setData(null); nav(`/carnet?reply=${id}`); };

  return (
    <div style={s.backdrop} data-testid="review-alert">
      <div style={s.card}>
        <button style={s.x} onClick={() => setData(null)} data-testid="review-alert-close"><IoClose size={20} /></button>
        <div style={s.avatarWrap}><img src={img} alt="Nerodus" style={s.avatar} /></div>
        <div style={s.badge}>{data.sensei_name || "Le Sensei"} t'a répondu</div>
        <h2 style={s.title}>{first ? `${first}, ` : ""}ta relecture a une réponse !</h2>
        <p style={s.text}>« {data.title} » vient de recevoir un retour. Va vite le découvrir dans ton carnet.</p>
        <button style={s.btn} onClick={go} data-testid="review-alert-go">Voir la réponse <IoArrowForward size={17} /></button>
      </div>
    </div>
  );
}

const s = {
  backdrop: { position: "fixed", inset: 0, zIndex: 9500, background: "rgba(0,0,0,0.72)", backdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 },
  card: { position: "relative", width: "min(440px,100%)", background: "var(--bg-secondary,#fff)", borderRadius: 24, padding: "34px 28px", textAlign: "center", border: `1px solid ${RED}44`, boxShadow: `0 30px 80px rgba(0,0,0,0.5), 0 0 60px ${RED}33`, animation: "nerodusIn .3s cubic-bezier(.16,1,.3,1)" },
  x: { position: "absolute", top: 14, right: 14, width: 32, height: 32, borderRadius: 8, border: "1px solid var(--border-c)", background: "var(--bg-tertiary)", color: "var(--text-secondary)", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" },
  avatarWrap: { width: 110, height: 110, borderRadius: "50%", overflow: "hidden", margin: "0 auto 14px", border: `3px solid ${RED}`, boxShadow: `0 0 40px ${RED}66`, background: "var(--bg-primary)" },
  avatar: { width: "100%", height: "100%", objectFit: "cover", objectPosition: "top center" },
  badge: { display: "inline-block", padding: "5px 14px", borderRadius: 999, background: `${RED}18`, color: RED, fontWeight: 800, fontSize: 12.5, marginBottom: 12, textTransform: "uppercase", letterSpacing: 0.5 },
  title: { fontSize: 23, fontWeight: 900, color: "var(--text-primary)", fontFamily: "var(--font-display)", margin: "0 0 8px" },
  text: { fontSize: 15, color: "var(--text-secondary)", lineHeight: 1.6, margin: "0 0 22px" },
  btn: { display: "inline-flex", alignItems: "center", gap: 8, padding: "13px 26px", borderRadius: 12, border: "none", background: RED, color: "#fff", fontWeight: 800, fontSize: 15, cursor: "pointer", boxShadow: `0 10px 30px ${RED}55` },
};
